module.exports = __webpack_public_path__ + "img/logo.dbc43d27.png";